module.exports = __webpack_public_path__ + "static/media/close-icon.85a992c3.svg";